module.exports = __webpack_public_path__ + "img/kddi.e98878a5.png";